import { useEffect, useState } from 'react';

/**
 * A phone held sideways (KAN-984): landscape AND short. Width alone cannot say it — an iPhone SE on
 * its side is 667 wide (the "phone" layout) while a Pro Max is 956 (already "tablet") — so the home
 * screens ask this query to pick their side-by-side arrangement on every phone held sideways.
 *
 * The SAME query is written in CSS (homeToday.css, homeWorkerDay.css); keep them in step.
 * matchMedia, never a raw innerWidth read (noRawViewportWidth.test.js).
 */
export const LANDSCAPE_PHONE_QUERY = '(orientation: landscape) and (max-height: 500px)';

const canMatch = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';
const read = () => (canMatch() ? window.matchMedia(LANDSCAPE_PHONE_QUERY).matches : false);

export default function useIsLandscapePhone() {
  const [landscapePhone, setLandscapePhone] = useState(read);
  useEffect(() => {
    if (!canMatch()) return undefined;
    const mql = window.matchMedia(LANDSCAPE_PHONE_QUERY);
    const onChange = () => setLandscapePhone(mql.matches);
    onChange();
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    if (typeof mql.addListener === 'function') {
      mql.addListener(onChange);
      return () => mql.removeListener(onChange);
    }
    return undefined;
  }, []);
  return landscapePhone;
}
